import { createStyles, Theme } from '@material-ui/core/styles';

import { colors } from '@shared/theme/colours';

export enum HeaderTheme {
  primary = 'primary',
  default = 'default',
}

export const styles = ({ spacing }: Theme) =>
  createStyles({
    root: {
      position: 'relative',
      zIndex: 2,
    },
    header: {
      width: '100%',
      padding: spacing(4),
      backgroundColor: colors.white.lightest,
      fontSize: 22,
    },
    [HeaderTheme.primary]: {
      backgroundColor: colors.kato.navy[900],

      '& $headerText': {
        color: colors.white.lightest,
      },
    },
    [HeaderTheme.default]: {
      backgroundColor: colors.white.lightest,

      '& $headerText': {
        color: colors.black.darker,
      },
    },
    withBorder: {
      borderBottom: '1px solid #EAECF0;', //TODO replace after creating new palette
      zIndex: 2,
    },
    headerContainer: {},
    headerText: {
      width: 'calc(100% - 50px)',
      overflow: 'hidden',
      fontWeight: 500,
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    headerIcon: {
      fontSize: 20,
      color: '#9EA6B3', //TODO replace after creating new palette
    },
    headerBtn: {
      minWidth: 38,
      border: 'none',
    },
    headerBtnSmall: {
      padding: '8px 9px',
    },
    headerActionsContainer: {
      alignItems: 'center',
      gap: 12,
    },
  });
